import styled from 'styled-components'

import { IconArrowRightSmall } from 'components/Icons/IconArrowRight'
import { IconMarker } from 'components/Icons/IconMarker'
import {
  getPositionRangeMax,
  getPositionRangeMin,
  getRangeBackgroundColor,
  getRangeBorderColor,
  getRangeMarkerPosition,
} from '../utils'
import { PositionDisplayInfo } from 'utils/userUserPositionDisplayInfos'

const RangeWrapper = styled.div`
  position: relative;
  width: calc(100% - 2px);
`

const RangeIndicator = styled.div<{ $percentage: number }>`
  border-radius: 8px;
  height: 8px;
  width: 100%;
  border: 1px solid ${p => getRangeBorderColor(p.$percentage, p.theme)};
  background-color: ${p => getRangeBackgroundColor(p.$percentage, p.theme)};
  margin-top: 6px;
`

const MarkerWrapper = styled.div<{ $percentage: number }>`
  position: absolute;
  left: ${({ $percentage }) =>
    $percentage <= 2 ? 'calc(0% + 4px)' : $percentage >= 99 ? 'calc(100% - 2px)' : `${$percentage}%`};
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 17px;
  pointer-events: none;
`

export const PositionRange = ({ displayInfo }: { displayInfo: PositionDisplayInfo }) => {
  const markerPosition = getRangeMarkerPosition(displayInfo.position.configInfo.isReversedPair, displayInfo)
  return (
    <div style={{ width: '100%' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ marginRight: 4 }}>
          {getPositionRangeMin(displayInfo.position.configInfo.isReversedPair, displayInfo)}
        </span>
        <IconArrowRightSmall />
        <span style={{ marginLeft: 4 }}>
          {getPositionRangeMax(displayInfo.position.configInfo.isReversedPair, displayInfo)}
        </span>
      </div>
      <RangeWrapper>
        <RangeIndicator $percentage={markerPosition} />
        <MarkerWrapper $percentage={markerPosition}>
          <IconMarker />
        </MarkerWrapper>
      </RangeWrapper>
    </div>
  )
}
